import React from 'react';
import './responsive-msg.css'
import pic42 from '../assets/pic42.png'

const Responsivemsg = () => {
    return ( 
        <section className='sec1-responsive-msg'>
                <article className='container-responsive-msg'>
                        <h1 className='header-responsivemsg'>Sorry!</h1>
                        <p className='para-responsivemsg'>This website is best viewed on a desktop device.
                            It is not currently optimized for small screens or
                             mobile devices.Please access the site using a desktop or 
                             laptop for the best experience.</p>
                        <img className='img-resp-msg' src={pic42} alt='pic'></img>
                </article>
        </section>
     );
}
 
export default Responsivemsg;